// extracted by mini-css-extract-plugin
export default {"content":"Content_content__3ZaEO","dark":"Content_dark__RO4EW","contentWrapper":"Content_contentWrapper__yq8Qs"};